module.exports = __webpack_public_path__ + "static/media/theMofG30.658678ca.png";